import React from "react";
import { Link } from "react-router-dom";

import NavLight from "../components/NavLight";
import ContactIcon from "../assets/curious-robo.svg";
import "./PageNotFound.css";
import { Helmet } from "react-helmet";

function PageNotFound() {
    return (
        <div className="PageNotFound">
            <Helmet>
                <title>Magic Feedback. Page Not Found. 404 error page.</title>
                <meta
                    name="description"
                    content="Magic Feedback. Page Not Found. 404 error page."
                />
            </Helmet>
            <NavLight />
            <div className="page-not-found-container">
                <div className="page-not-found-content">
                    <div className="page-not-found-content-details">
                        <h3>404</h3>
                        <h1>Page not found</h1>
                        <p>
                            Sorry, we couldn’t find the page you’re looking for.
                        </p>
                    </div>
                    <div className="page-not-found-content-btn">
                        <a href="/">
                            <p>Back to home</p>
                        </a>
                    </div>
                </div>
                <figure>
                    <img
                        src={ContactIcon}
                        alt="curious robot"
                        className="page-not-found-icon"
                    />
                </figure>
            </div>
        </div>
    );
}

export default PageNotFound;
